module.exports = "/shared/img/green-btn-background.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/green-btn-background.png
// module id = 439
// module chunks = 13